<template lang="pug">
.all-user-bookmarks
  h2.title-with-underline {{ $t('bookmarks.yourBookmarks') }}
  GenericContent(:content='userBookmarks', :limit='limit')
</template>

<script setup lang="ts">
  import { computed, onMounted, provide } from 'vue'

  import GenericContent from '@/components/curated-content/GenericContent.vue'

  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'

  import { BookmarksModule } from '@/store/modules/Bookmarks'

  const { trackPage, pageViewed } = useSegment()
  const { currentlyAllowedCourseIds } = useCourse()

  const limit = 10
  provide('itemPurpose', 'bookmarks')

  const userBookmarks = computed(() => {
    return Object.values(BookmarksModule.bookmarks).filter((bookmark) =>
      currentlyAllowedCourseIds.value.includes(bookmark.course.id),
    )
  })

  onMounted(() => {
    trackPage('Bookmarks')
    pageViewed('Bookmarks')
  })
</script>

<style lang="postcss">
  .all-user-bookmarks {
    > h2 {
      @apply ketch-font-bold ketch-mb-c40 ketch-pb-c20;
    }
  }
</style>
